import Vue from 'vue'
import VueRouter from 'vue-router'
import ConfigList from '../views/VCConfigList.vue'

Vue.use(VueRouter)

const routes = [
  
  {
    path: '/',
    name: 'List',
    component: ConfigList
  }
  /*{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ /*'../views/About.vue')
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.publicPath,
  routes
})

export default router
